import { render, staticRenderFns } from "./UserProfileModal.vue?vue&type=template&id=66933bb6&scoped=true&"
import script from "./UserProfileModal.vue?vue&type=script&lang=js&"
export * from "./UserProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileModal.vue?vue&type=style&index=0&id=66933bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66933bb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66933bb6')) {
      api.createRecord('66933bb6', component.options)
    } else {
      api.reload('66933bb6', component.options)
    }
    module.hot.accept("./UserProfileModal.vue?vue&type=template&id=66933bb6&scoped=true&", function () {
      api.rerender('66933bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/UserProfileModal.vue"
export default component.exports